import { render, staticRenderFns } from "./GsSync.vue?vue&type=template&id=a0e8c112&scoped=true"
import script from "./GsSync.vue?vue&type=script&lang=js"
export * from "./GsSync.vue?vue&type=script&lang=js"
import style0 from "./GsSync.vue?vue&type=style&index=0&id=a0e8c112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e8c112",
  null
  
)

export default component.exports